// extracted by mini-css-extract-plugin
export default {"form_wrapper":"Loan_Form_form_wrapper__umHyh","expand":"Loan_Form_expand__f1SMA","submit_btn":"Loan_Form_submit_btn__Oklf3"};